import * as React from 'react';
import { Box, Typography } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, SubmitButton } from 'components';
import { PaymentMethodForm } from 'forms';

interface PaymentMethodDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
}

export const PaymentMethodDialog = ({ visible = false, setVisible = () => {} }: PaymentMethodDialogProps) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  return (
    <Dialog onClose={onClose} open={visible}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          Update Payment Method
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ paddingY: 5 }}>
          <PaymentMethodForm
            ref={formRef}
            onLoading={(loading) => setLoading(loading)}
            next={() => setVisible(false)}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading} label={'Update'} onClick={() => formRef.current.onSubmit()} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
